import React, { Component } from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import anime from 'animejs';
import Vivus from 'vivus';
import { IconLoader } from './icons';
import styled from 'styled-components';
import { theme, mixins } from '../styles';
const { colors } = theme;

const LoaderContainer = styled.div`
  ${mixins.flexCenter};
  background-color: ${colors.darkNavy};
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
`;
const LogoWrapper = styled.div`
  width: max-content;
  max-width: 100px;
  transition: ${theme.transition};
  opacity: ${props => (props.isMounted ? 1 : 0)};
  svg {
    width: 1000px;
    height: 1000px;
    transform: translate(-459px, 0px);
  }
`;

class Loader extends Component {
  static propTypes = {
    finishLoading: PropTypes.func.isRequired,
  };

  state = {
    isMounted: false,
  };

  componentDidMount() {
    this.setState({ isMounted: true }, () => this.animate());
  }

  componentWillUnmount() {
    this.setState({ isMounted: false });
  }

  animate() {
    const { finishLoading } = this.props;

    var done = false;

    const load = new Vivus('nameplate', {
      type: 'oneByOne',
      start: 'manual',
      duration: 575,
      animTimingFunction: Vivus.LINEAR,
    });

    load.play(function() {
          done = true;
          finishLoading();
    });

  }

  render() {
    const { isMounted } = this.state;

    return (
      <LoaderContainer className="loader">
        <Helmet>
          <body className={isMounted ? 'hidden' : ''} />
        </Helmet>
        <LogoWrapper isMounted={isMounted}>
          <IconLoader />
        </LogoWrapper>
      </LoaderContainer>
    );
  }
}

export default Loader;
